// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PrimeReact component overrides — loaded after Lara theme + brand tokens.
 */
:root {
  --primary-color: #8f653a;
  --primary-color-text: #ffffff;

  --primary-50: #faf7f3;
  --primary-100: #eee2d5;
  --primary-200: #dec8b1;
  --primary-300: #c9a47f;
  --primary-400: #ad8054;
  --primary-500: #8f653a;
  --primary-600: #79532f;
  --primary-700: #624328;
  --primary-800: #4d3522;
  --primary-900: #39281b;

  --focus-ring: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);
  --highlight-bg: rgba(143, 101, 58, 0.18);
  --highlight-text-color: #ffffff;
}

/* Inputs and form controls */
.p-inputtext:enabled:focus,
.p-dropdown:not(.p-disabled).p-focus,
.p-multiselect:not(.p-disabled).p-focus,
.p-treeselect:not(.p-disabled).p-focus,
.p-cascadeselect:not(.p-disabled).p-focus,
.p-autocomplete .p-autocomplete-multiple-container.p-focus,
.p-chips .p-chips-multiple-container.p-focus {
  border-color: #8f653a;
  box-shadow: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);
}

/* Buttons */
.p-button {
  background: #8f653a;
  border-color: #8f653a;
  color: #ffffff;
}

.p-button:not(:disabled):hover {
  background: #79532f;
  border-color: #79532f;
  color: #ffffff;
}

.p-button:not(:disabled):active {
  background: #624328;
  border-color: #624328;
  color: #ffffff;
}

.p-button:focus {
  box-shadow: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);
}

/* Selected items */
.p-highlight,
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight,
.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight,
.p-listbox .p-listbox-list .p-listbox-item.p-highlight {
  background: rgba(143, 101, 58, 0.18);
  color: #ffffff;
}

/* Checkbox and radio — PrimeReact 10: p-highlight is on the root (.p-checkbox / .p-radiobutton) */
.p-checkbox.p-highlight .p-checkbox-box,
.p-radiobutton.p-highlight .p-radiobutton-box {
  background: var(--brand-500);
  border-color: var(--brand-500);
}

.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box,
.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight .p-radiobutton-box {
  background: var(--brand-600);
  border-color: var(--brand-600);
}

.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box,
.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
  border-color: var(--brand-500);
}

.p-checkbox:not(.p-disabled):has(.p-checkbox-input:focus-visible) .p-checkbox-box,
.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible) .p-radiobutton-box {
  border-color: var(--brand-500);
  box-shadow: var(--focus-ring);
}

.p-input-filled .p-checkbox.p-highlight .p-checkbox-box,
.p-input-filled .p-radiobutton.p-highlight .p-radiobutton-box,
.p-checkbox.p-variant-filled.p-highlight .p-checkbox-box,
.p-radiobutton.p-variant-filled.p-highlight .p-radiobutton-box {
  background: var(--brand-500);
  border-color: var(--brand-500);
}

.p-input-filled .p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box,
.p-input-filled .p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight .p-radiobutton-box,
.p-checkbox.p-variant-filled:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box,
.p-radiobutton.p-variant-filled:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight .p-radiobutton-box {
  background: var(--brand-600);
  border-color: var(--brand-600);
}

/* Switch */
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background: #8f653a;
}

.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {
  background: #79532f;
}
`, "",{"version":3,"sources":["webpack://./src/styles/prime-brand-overrides.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,wBAAwB;EACxB,6BAA6B;;EAE7B,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,mDAAmD;EACnD,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;;;;;;;EAOE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;;;;EAIE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,kGAAkG;AAClG;;EAEE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;;;EAIE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;;;EAIE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\n * PrimeReact component overrides — loaded after Lara theme + brand tokens.\n */\n:root {\n  --primary-color: #8f653a;\n  --primary-color-text: #ffffff;\n\n  --primary-50: #faf7f3;\n  --primary-100: #eee2d5;\n  --primary-200: #dec8b1;\n  --primary-300: #c9a47f;\n  --primary-400: #ad8054;\n  --primary-500: #8f653a;\n  --primary-600: #79532f;\n  --primary-700: #624328;\n  --primary-800: #4d3522;\n  --primary-900: #39281b;\n\n  --focus-ring: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);\n  --highlight-bg: rgba(143, 101, 58, 0.18);\n  --highlight-text-color: #ffffff;\n}\n\n/* Inputs and form controls */\n.p-inputtext:enabled:focus,\n.p-dropdown:not(.p-disabled).p-focus,\n.p-multiselect:not(.p-disabled).p-focus,\n.p-treeselect:not(.p-disabled).p-focus,\n.p-cascadeselect:not(.p-disabled).p-focus,\n.p-autocomplete .p-autocomplete-multiple-container.p-focus,\n.p-chips .p-chips-multiple-container.p-focus {\n  border-color: #8f653a;\n  box-shadow: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);\n}\n\n/* Buttons */\n.p-button {\n  background: #8f653a;\n  border-color: #8f653a;\n  color: #ffffff;\n}\n\n.p-button:not(:disabled):hover {\n  background: #79532f;\n  border-color: #79532f;\n  color: #ffffff;\n}\n\n.p-button:not(:disabled):active {\n  background: #624328;\n  border-color: #624328;\n  color: #ffffff;\n}\n\n.p-button:focus {\n  box-shadow: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);\n}\n\n/* Selected items */\n.p-highlight,\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight,\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight,\n.p-listbox .p-listbox-list .p-listbox-item.p-highlight {\n  background: rgba(143, 101, 58, 0.18);\n  color: #ffffff;\n}\n\n/* Checkbox and radio — PrimeReact 10: p-highlight is on the root (.p-checkbox / .p-radiobutton) */\n.p-checkbox.p-highlight .p-checkbox-box,\n.p-radiobutton.p-highlight .p-radiobutton-box {\n  background: var(--brand-500);\n  border-color: var(--brand-500);\n}\n\n.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box,\n.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight .p-radiobutton-box {\n  background: var(--brand-600);\n  border-color: var(--brand-600);\n}\n\n.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box,\n.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {\n  border-color: var(--brand-500);\n}\n\n.p-checkbox:not(.p-disabled):has(.p-checkbox-input:focus-visible) .p-checkbox-box,\n.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible) .p-radiobutton-box {\n  border-color: var(--brand-500);\n  box-shadow: var(--focus-ring);\n}\n\n.p-input-filled .p-checkbox.p-highlight .p-checkbox-box,\n.p-input-filled .p-radiobutton.p-highlight .p-radiobutton-box,\n.p-checkbox.p-variant-filled.p-highlight .p-checkbox-box,\n.p-radiobutton.p-variant-filled.p-highlight .p-radiobutton-box {\n  background: var(--brand-500);\n  border-color: var(--brand-500);\n}\n\n.p-input-filled .p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box,\n.p-input-filled .p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight .p-radiobutton-box,\n.p-checkbox.p-variant-filled:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box,\n.p-radiobutton.p-variant-filled:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight .p-radiobutton-box {\n  background: var(--brand-600);\n  border-color: var(--brand-600);\n}\n\n/* Switch */\n.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {\n  background: #8f653a;\n}\n\n.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {\n  background: #79532f;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
